const BASE_URL = 'https://axofinans.appfarm.app/axo-insurance-mypage';

export const insuranceMypageNo = { mypageInsurance: BASE_URL };
export const insuranceMypageSe = { mypageInsurance: `${BASE_URL}?country=SE` };
export const insuranceMypageFi = { mypageInsurance: `${BASE_URL}?country=FI` };
export const insuranceMypageDk = { mypageInsurance: `${BASE_URL}?country=DK` };
